export const uriRoles = {
  ProjectPage: '/asset-project',
  ProjectList: '/pm/project',
  ProjectCreate: '/pm/project/create',
  ProjectDetail: '/pm/project/detail',
  ProjectEdit: '/pm/project/edit',
  ProjectDelete: '/pm/project/delete',
  ProjectDetailAppraisal: '/pm/project/detail-appraisal',
  ProjectExportExcel: '/pm/project/export-excel',
  ProjectFinancialCreate: '/pjm/project-financial/create',
  ProjectFinancialEdit: '/pjm/project-financial/update',
  ProjectFinancialDelete: '/pjm/project-financial/delete',
  ProjectFinancialSearch: '/pjm/project-financial/search',
  ProjectAccountingYearReport: '/pm/report/project-financial-year-report',

  ProjectAppraisal: '/pm/appraisal',
  ProjectAppraisalCreate: '/pm/appraisal/create',
  ProjectAppraisalDetail: '/pm/appraisal/detail',
  ProjectAppraisalEdit: '/pm/appraisal/edit',
  ProjectAppraisalDelete: '/pm/appraisal/delete',

  ProjectAggregationCycle: '/pm/aggregation-cycle',
  ProjectAggregationCycleDetail: '/pm/aggregation-cycle/detail',
  ProjectAggregationCycleCreate: '/pm/aggregation-cycle/create',
  ProjectAggregationCycleExportExcel: '/pm/aggregation-cycle/export-excel',

  DraftProjectSearch: '/pm/draft-project/search',
  DraftProjectDetail: '/pm/draft-project/detail',
  DraftProjectCreate: '/pm/draft-project/create',
  DraftProjectUpdate: '/pm/draft-project/update',
  DraftProjectDelete: '/pm/draft-project/delete',
  DraftProjectCancel: '/pm/draft-project/cancel',
  DraftProjectApprove: '/pm/draft-project/approve',
  DraftProjectSubmit: '/pm/draft-project/submit',
  DraftProjectExportExcel: '/pm/draft-project/export-excel',
  DraftProjectGenerateReviewers: '/pm/draft-project/generate-reviewers',
  DraftProjectRevoke: '/pm/draft-project/revoke',

  ContractorList: '/pm/contractor',
  ContractorCreate: '/pm/contractor/create',
  ContractorDetail: '/pm/contractor',
  ContractorEdit: '/pm/contractor/update',
  ContractorDelete: '/pm/contractor/delete',
  ContractorExportExcel: '/pm/contractor/export-excel',

  TaskList: '/tm/task/search',
  TaskCreate: '/tm/task/create',
  TaskDetail: '/tm/task/detail',
  TaskEdit: '/tm/task/edit',
  TaskDelete: '/tm/task/delete',

  TaskExportExcel: '/tm/task/export-excel',
  TaskAssign: '/tm/task/assign',
  TaskAlert: '/tm/task/alert',

  TaskHistory: '/tm/task/history',

  TaskCommentList: '/tm/task/comment-list',
  TaskCommentCreate: '/tm/task/comment-create',
  TaskCommentUpdate: '/tm/task/comment-update',
  TaskCommentDelete: '/tm/task/comment-delete',

  CostEstimateList: '/pjm/cost-estimate',
  CostEstimateCreate: '/pjm/cost-estimate/create',
  CostEstimateDetail: '/pjm/cost-estimate/detail',
  CostEstimateEdit: '/pjm/cost-estimate/update',
  CostEstimateDelete: '/pjm/cost-estimate/delete',

  SettingsMenuList: '/settings/index',

  SettingsCheckList: '/settings/check-list',
  SettingsCheckListSearch: '/settings/check-list/search',
  SettingsCheckListSelf: '/settings/check-list/self',
  SettingsCheckListCreate: '/settings/check-list/create',
  SettingsCheckListUpdate: '/settings/check-list/update',
  SettingsCheckListDelete: '/settings/check-list/delete',
  SettingsCheckListExportExcel: '/settings/check-list/export-excel',

  SettingsCheckListDetail: '/settings/check-list-detail',
  SettingsCheckListDetailSearch: '/settings/check-list-detail/search',
  SettingsCheckListDetailCreate: '/settings/check-list-detail/create',
  SettingsCheckListDetailUpdate: '/settings/check-list-detail/update',
  SettingsCheckListDetailDelete: '/settings/check-list-detail/delete',
  SettingsCheckListDetailExportExcel: '/settings/check-list-detail/export-excel',

  ProjectDocumentChecklistSearch: '/pm/project-check-list/search',
  ProjectDocumentChecklistCreate: '/pm/project-check-list/create',
  ProjectDocumentChecklistUpdate: '/pm/project-check-list/update',
  ProjectDocumentChecklistExportExcel: '/pm/project-check-list/export-excel',

  ProjectType: '/settings/project-type',
  ProjectTypeSearch: '/settings/project-type/search',
  ProjectTypeCreate: '/settings/project-type/create',
  ProjectTypeUpdate: '/settings/project-type/update',
  ProjectTypeDelete: '/settings/project-type/delete',
  ProjectTypeExportExcel: '/settings/project-type/export-excel',

  ObjectiveType: '/settings/objective-type',
  ObjectiveTypeSearch: '/settings/objective-type/search',
  ObjectiveTypeCreate: '/settings/objective-type/create',
  ObjectiveTypeUpdate: '/settings/objective-type/update',
  ObjectiveTypeDelete: '/settings/objective-type/delete',
  ObjectiveTypeExportExcel: '/settings/objective-type/export-excel',

  LegalType: '/settings/legal-type',
  LegalTypeSearch: '/settings/legal-type/search',
  LegalTypeCreate: '/settings/legal-type/create',
  LegalTypeUpdate: '/settings/legal-type/update',
  LegalTypeDelete: '/settings/legal-type/delete',
  LegalTypeExportExcel: '/settings/legal-type/export-excel',

  InvestType: '/settings/invest-type',
  InvestTypeSearch: '/settings/invest-type/search',
  InvestTypeCreate: '/settings/invest-type/create',
  InvestTypeUpdate: '/settings/invest-type/update',
  InvestTypeDelete: '/settings/invest-type/delete',
  InvestTypeExportExcel: '/settings/invest-type/export-excel',

  Important: '/settings/important',
  ImportantSearch: '/settings/important/search',
  ImportantCreate: '/settings/important/create',
  ImportantUpdate: '/settings/important/update',
  ImportantDelete: '/settings/important/delete',
  ImportantExportExcel: '/settings/important/export-excel',

  ContractorType: '/settings/contractor-type',
  ContractorTypeSearch: '/settings/contractor-type/search',
  ContractorTypeCreate: '/settings/contractor-type/create',
  ContractorTypeUpdate: '/settings/contractor-type/update',
  ContractorTypeDelete: '/settings/contractor-type/delete',
  ContractorTypeExportExcel: '/settings/contractor-type/export-excel',

  CapitalType: '/settings/capital-type',
  CapitalTypeSearch: '/settings/capital-type/search',
  CapitalTypeCreate: '/settings/capital-type/create',
  CapitalTypeUpdate: '/settings/capital-type/update',
  CapitalTypeDelete: '/settings/capital-type/delete',
  CapitalTypeExportExcel: '/settings/capital-type/export-excel',

  BudgetType: '/settings/budget-type',
  BudgetTypeSearch: '/settings/budget-type/search',
  BudgetTypeCreate: '/settings/budget-type/create',
  BudgetTypeUpdate: '/settings/budget-type/update',
  BudgetTypeDelete: '/settings/budget-type/delete',
  BudgetTypeExportExcel: '/settings/budget-type/export-excel',

  TaskState: '/settings/task-state',
  TaskStateSearch: '/settings/task-state/search',
  TaskStateCreate: '/settings/task-state/create',
  TaskStateUpdate: '/settings/task-state/update',
  TaskStateDelete: '/settings/task-state/delete',
  TaskStateExportExcel: '/settings/task-state/export-excel',

  TaskPriority: '/settings/task-priority',
  TaskPrioritySearch: '/settings/task-priority/search',
  TaskPriorityCreate: '/settings/task-priority/create',
  TaskPriorityUpdate: '/settings/task-priority/update',
  TaskPriorityDelete: '/settings/task-priority/delete',
  TaskPriorityExportExcel: '/settings/task-priority/export-excel',

  AppraisalList: '/pjm/config-request-org/search',
  AppraisalCreate: '/pjm/config-request-org/create',
  AppraisalUpdate: '/pjm/config-request-org/update',
  AppraisalDelete: '/pjm/config-request-org/delete',
  AppraisalDetail: '/pjm/config-request-org/self',
  AppraisalUpdateStatus: '/pjm/config-request-org/update-status',

  CloseProject: '/settings/close-project',
  CloseProjectSearch: '/settings/close-project/search',
  CloseProjectCreate: '/settings/close-project/create',
  CloseProjectUpdate: '/settings/close-project/update',
  CloseProjectDelete: '/settings/close-project/delete',
  CloseProjectExportExcel: '/settings/close-project/export-excel',
}
